import { MutationTree } from 'vuex'
import { TriggeredReferralState } from '@/store/triggeredReferrals/index'
import { PageResult } from '@/api/types'
import { TriggeredReferral } from '@/api/model/triggered-referral'

export const mutations: MutationTree<TriggeredReferralState> = {
    fetchData(state: TriggeredReferralState): void {
        state.loading = true
        state.totalItems = null
        state.error = null
    },

    fetchDataSuccess(state: TriggeredReferralState, result: PageResult<TriggeredReferral>): void {
        state.loading = false
        state.error = null
        state.triggeredReferrals = result.collection
        state.totalItems = result.totalItems
        state.totalPages = result.totalPages
    },

    fetchDataFailure(state: TriggeredReferralState, error: string): void {
        state.loading = false
        state.error = error
    },

    setPage(state: TriggeredReferralState, payload: {page: number }): void {
        state.page = payload.page
    },

    applyOrder(state: TriggeredReferralState, payload: { field: string, direction: string}): void {
        state.orderField = payload.field
        state.orderDirection = payload.direction
    },

    applyActiveFilter(state: TriggeredReferralState, payload: {activeFilter: number[] }): void {
        state.activeFilter = payload.activeFilter
    },

    applyCompanyFilter(state: TriggeredReferralState, payload: {query: string }): void {
        state.companyFilter = payload.query
    },

    applyNameFilter(state: TriggeredReferralState, payload: { query: string}): void {
        state.nameFilter = payload.query
    },

    resetFilters(state: TriggeredReferralState): void {
        state.activeFilter = null
        state.nameFilter = null
    },
}
